

































































































































































































































const ExcelJS = require("exceljs");
import { Component, Prop, Vue } from "vue-property-decorator";
import ModalHeader from "../ModalHeader.vue";
import { VueEditor } from "vue2-editor";
import { GapLogEntry } from "@/store/modules/types";
import { GapLogType } from "@/store/modules/enums";
import { randomId } from "@/utils";
import LogFilter from "@/components/gap/filters/LogType.vue";
import { getDate } from '@/services/timezone';

@Component({
  components: {
    ModalHeader,
    VueEditor,
    LogFilter
  },
})
export default class GapLog extends Vue {
  @Prop() readonly gap: any;
  @Prop() readonly embedded?: boolean;
  @Prop() readonly showComment: boolean = true;
  log: Array<any> = [];
  comment = "";
  showLogFilter = false;
  logType = GapLogType.OFFICE_CALL;
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };
  getDate = getDate;
  async getLog() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { logTypeList } = this.$store.state.gaps.filter;
      this.log = await this.$store.dispatch("gaps/getLogById", {id:this.gap.id,typeList:logTypeList});
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveComment() {
    if (!this.comment) return;
    const entry: GapLogEntry = {
      gapId: this.gap.id,
      typeId: this.logType,
      comment: this.comment,
    };
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("gaps/saveLog", entry);
      this.getLog();
      this.comment = "";
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

 async exportLog() {
    const moment: any = this.$moment;
    var reportTitle = "GAP LOG REPORT";
    var subtitle = "";
    var fileName =
      "gap_log_report_" + this.$moment().format("MMDDYYYY_hhmma");
    const reportDate = this.$moment()
      .format("MMM DD YYYY hh:mm A")
      .toUpperCase();
    const reportRangeDate = "";
    const patient = this.gap.patientName + "(#" + String(this.gap.id).padStart(7, "0") +")";
    const patientBirthdate = "DOB: " + moment(this.gap.patientBirthdate).format("MM/DD/YYYY");
    const insurerMemberId = "MemberID: " +this.gap.insurerMemberId;

    const header = [
     "Name",
      "Comment",
      "UserName",
      "Date",
      "Time"
    ];
    const font = {
      name: "Calibri",
      family: 2,
      size: 16,
      underline: false,
      bold: true,
    };
    const alignment = {
      vertical: "middle",
      horizontal: "right",
    };
    const data: any = [];
    var total = 0;
   
    for (const log of this.log) {
      var row: any = [];
      row.push(log.typeName);
      row.push(log.reportComment);
      row.push(log.userName);
      row.push(moment(log.recordDate).format("MM/DD/YYYY"));
      row.push( moment(log.recordDate, "HH:mm:ss").format("hh:mm A"));
      data.push(row);
    }
    //Create workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "PatientCare";
    workbook.lastModifiedBy = "PatientCare";
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();

    const worksheet = workbook.addWorksheet("Report");

    //Add Row and formatting
     let reportTitleRow = (worksheet.getCell("D1").value = reportTitle);
    let reportDateRow = (worksheet.getCell("D2").value = reportDate);
    let patientRow = (worksheet.getCell("D3").value = patient);
    let patientBirthdateRow = (worksheet.getCell("D4").value = patientBirthdate);
    let insurerMemberIdRow = (worksheet.getCell("D5").value = insurerMemberId);

    // Set font, size and style in title row.
    worksheet.mergeCells("D1:E1");
    worksheet.mergeCells("D2:E2");
    worksheet.mergeCells("D3:E3");
    worksheet.mergeCells("D4:E4");
    worksheet.mergeCells("D5:E5");

    worksheet.getCell("D1").font = font;
    worksheet.getCell("D2").font = font;
    worksheet.getCell("D3").font = font;
    worksheet.getCell("D4").font = font;
    worksheet.getCell("D5").font = font;

    worksheet.getCell("D1").alignment = alignment;
    worksheet.getCell("D2").alignment = alignment;
    worksheet.getCell("D3").alignment = alignment;
    worksheet.getCell("D4").alignment = alignment;
    worksheet.getCell("D5").alignment = alignment;

    //Add logo
    var img = new Image();

    img.onload = function () {
      var canvas: any = document.createElement("CANVAS");
      var ctx = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(this, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      canvas = null;

      //Add Image
      let logo = workbook.addImage({
        base64: dataURL,
        extension: "png",
      });

      worksheet.addImage(logo, "A1:B4");
      worksheet.mergeCells("A1", "B4");

      // Blank Row
      worksheet.addRow([]);

      //Add waitingList row
      let subTitleRow = worksheet.addRow([subtitle]); //subtitle
      worksheet.mergeCells("A6:I6");

      subTitleRow.eachCell((cell, number) => {
        cell.border = {
          top: {
            style: "thin",
            color: {
              argb: "87CEEB",
            },
          },
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 14,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "87CEEB",
          },
          bgColor: {
            argb: "FFFFFF",
          },
        };
        cell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //add data
      worksheet.addRows(data);

      //column width
      worksheet.getColumn(1).width = 30;
      worksheet.getColumn(2).width = 30;
      worksheet.getColumn(3).width = 16;
      worksheet.getColumn(4).width = 16;
      worksheet.getColumn(5).width = 30;
      worksheet.getColumn(6).width = 16;
      worksheet.getColumn(7).width = 30;
      worksheet.getColumn(8).width = 30;
      worksheet.getColumn(9).width = 30;
      worksheet.getColumn(10).width = 30;
      worksheet.getColumn(11).width = 30;

      //Footer Row
      const footerFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FFFFFF",
        },
      };

      var emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:E${emptyRow.number}`);

      let footerRow = worksheet.addRow(["Total: " + data.length + " Records"]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:E${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "service@waitingmed.com · www.waitingmed.com",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:E${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "Calle Luis Pales Matos FF-15, Levittown, PR 00949",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:E${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:E${emptyRow.number}`);
      //save
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //app.saveAs(blob, fileName + '.xlsx');
        var url = window.URL.createObjectURL(blob);

        var doc = document.createElement("a");
        doc.href = url;
        doc.download = fileName + ".xlsx";
        doc.click();
        window.URL.revokeObjectURL(url);
      });
    };

    img.src = require("../../assets/wmpc_logo.png"); 
  }

 /*end */
  async markRead(log) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("gaps/markLogRead", log.id);
      this.getLog();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  get unreadComments() {
    return this.log.filter((row) => {
      return (
        !row.isRead &&
        (row.typeId === GapLogType.PATIENT_COMMENT ||
          row.typeId === GapLogType.PROVIDER_COMMENT)
      );
    });
  }
  mounted() {
    this.getLog();
  }
}
